<template>
  <BApp>
    <!-- Important that NotificationContainer is outside of AuthenticatorWrapper -->
    <NotificationContainer />
    <AuthenticatorWrapper>
      <AppHeader />
      <div class="d-flex flex-column align-items-center">
        <!-- <h3>Hello {{ auth.user?.username }}!</h3> -->
        <main class="mt-3" style="width: 90%">
          <RouterView />
        </main>
      </div>
      <UserInactivityTracker />
    </AuthenticatorWrapper>
  </BApp>
</template>

<script setup>
// Import Bootstrap Vue Next components
import { BApp } from "bootstrap-vue-next";

// Import notification system
import NotificationContainer from "@/components/molecules/NotificationContainer.vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

import { Amplify } from "aws-amplify";
import "@aws-amplify/ui-vue/styles.css";
import awsconfig from "@/aws-exports.js";

import UserInactivityTracker from "@/components/molecules/UserInactivityTracker.vue";
import AppHeader from "@/components/atoms/AppHeader.vue";
import AuthenticatorWrapper from "@/components/molecules/AuthenticatorWrapper.vue";

// Configure Amplify with the AWS exports
Amplify.configure(awsconfig);
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
/*floating-group START Using this to customize positioning of form labels*/
.floating-group {
  position: relative;
  margin-top: 8px;
}

.floating-group .form-label,
.floating-group .col-form-label,
.floating-group legend {
  position: absolute;
  border-radius: 5px;
  top: -8px;
  left: 12px;
  display: inline-block;
  width: fit-content;
  max-width: calc(100% - 24px);
  white-space: nowrap;
  background: white;
  padding: 0 4px;
  font-size: 0.75rem;
  z-index: 10;
  color: #6c757d;
}
/*floating-group END */
</style>
